import type { DomApplier } from '../cssFeatures.types'
import { getVariantKey, getVariantSelectors } from '../../utils/variantsUtils'
import type { SelectorToCssString } from '../../shared.types'

export const presetsDomApplier: DomApplier<'presets'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ presetsOutput },
	cssContext
) => {
	if (!presetsOutput) {
		return null
	}
	const { presets, supportExternalDependenciesCss } = presetsOutput

	const domApplierOutput: SelectorToCssString = {}

	for (const selectorKey in presets) {
		const presetInBp = presets[selectorKey]?.[breakpointId]

		if (presetInBp) {
			presetInBp.reduce((acc: SelectorToCssString, presetData) => {
				const { presetCss, variants } = presetData

				const rootSelector: string = getVariantSelectors(
					getVariantKey(variants),
					variants,
					compId,
					cssContext,
					{
						shouldTargetBuilderWrapper: selectorKey === 'root' || !supportExternalDependenciesCss,
						supportExternalDependenciesCss
					}
				).join(',')

				const selector = selectorKey === 'root' ? rootSelector : `${rootSelector}${supportExternalDependenciesCss ? '' : ' '}${selectorKey}`
				const presetCssWithSelector = `${selector}{${presetCss as string}}`

				if (acc[selector]) {
					acc[selector] += presetCssWithSelector
				} else {
					acc[selector] = presetCssWithSelector
				}
				return acc
			}, domApplierOutput)
		}
	}

	return Object.keys(domApplierOutput).length ? domApplierOutput : null
}
